module.exports = {
  VIF_Kategorie: {
    label: 'VIF-Indikator',
    values: {
      'VIF+': { label: 'Kat VIF+', color: '#be0021', order: 0 },
      VIF: { label: 'Kat VIF', color: '#e46c0a', order: 1 },
      A: { label: 'Kat A', color: '#fafa62', order: 2 },
      B: { label: 'Kat B', color: '#a9c571', order: 3 },
      C: { label: 'Kat C', color: '#5fb1a9', order: 4 },
      D: { label: 'Kat D', color: '#009bd2', order: 5 },
    },
    kooperationen: ['koop_u3J_GEM', 'koop_3_6J_GEM', 'koop_NMB_GEM'],
  },
  oeffTag_0_3J: {
    label: 'Betreuung der unter 3-jährigen Kinder',
    shortLabel: 'Betreuung unter 3-Jähriger',
    values: {
      '9,5': { label: 'min. 9½ h', color: '#be0021', order: 0 },
      '8': { label: 'min. 8 h', color: '#fafa62', order: 1 },
      'unter 8': { label: 'unter 8 h', color: '#009bd2', order: 2 },
      '': { label: 'keine Einrichtung vorhanden', color: '#ffffff', order: 3 },
    },
    kooperationen: ['koop_u3J_GEM'],
  },
  oeffTag_3_6J: {
    label: 'Betreuung der 3- bis 6-jährigen Kinder',
    shortLabel: 'Betreuung 3- bis 6-Jähriger',
    values: {
      '9,5': { label: 'min. 9½ h', color: '#be0021', order: 0 },
      '8': { label: 'min. 8 h', color: '#fafa62', order: 1 },
      'unter 8': { label: 'unter 8 h', color: '#009bd2', order: 2 },
      '': { label: 'keine Einrichtung vorhanden', color: '#ffffff', order: 3 },
    },
    kooperationen: ['koop_3_6J_GEM'],
  },
  oeffWoche_0_3J: {
    label: 'Betreuung der unter 3-jährigen Kinder',
    shortLabel: 'Betreuung unter 3-Jähriger',
    values: {
      '45': { label: 'min. 45 h', color: '#be0021', order: 0 },
      '35': { label: 'min. 35 h', color: '#fafa62', order: 1 },
      'unter 35': { label: 'unter 35 h', color: '#009bd2', order: 2 },
      '': { label: 'keine Einrichtung vorhanden', color: '#ffffff', order: 3 },
    },
    kooperationen: ['koop_u3J_GEM'],
  },
  oeffWoche_3_6J: {
    label: 'Betreuung der 3- bis 6-jährigen Kinder',
    shortLabel: 'Betreuung 3- bis 6-Jähriger',
    values: {
      '45': { label: 'min. 45 h', color: '#be0021', order: 0 },
      '35': { label: 'min. 35 h', color: '#fafa62', order: 1 },
      'unter 35': { label: 'unter 35 h', color: '#009bd2', order: 2 },
      '': { label: 'keine Einrichtung vorhanden', color: '#ffffff', order: 3 },
    },
    kooperationen: ['koop_3_6J_GEM'],
  },
  geschlJahr_0_3J: {
    label: 'Betreuung der unter 3-jährigen Kinder',
    shortLabel: 'Betreuung unter 3-Jähriger',
    values: {
      '25': { label: 'max. 25 Tage zu', color: '#be0021', order: 0 },
      '35': { label: '26 bis 35 Tage zu', color: '#fafa62', order: 1 },
      '55': { label: '36 bis 55 Tage zu', color: '#5fb1a9', order: 2 },
      'über 55': { label: 'mehr als 55 Tage zu', color: '#009bd2', order: 3 },
      '': { label: 'keine Einrichtung vorhanden', color: '#ffffff', order: 3 },
    },
    kooperationen: ['koop_u3J_GEM'],
  },
  geschlJahr_3_6J: {
    label: 'Betreuung der 3- bis 6-jährigen Kinder',
    shortLabel: 'Betreuung 3- bis 6-Jähriger',
    values: {
      '25': { label: 'max. 25 Tage zu', color: '#be0021', order: 0 },
      '35': { label: '26 bis 35 Tage zu', color: '#fafa62', order: 1 },
      '55': { label: '36 bis 55 Tage zu', color: '#5fb1a9', order: 2 },
      'über 55': { label: 'mehr als 55 Tage zu', color: '#009bd2', order: 3 },
      '': { label: 'keine Einrichtung vorhanden', color: '#ffffff', order: 3 },
    },
    kooperationen: ['koop_3_6J_GEM'],
  },
  Mittagessen_0_3: {
    label: 'Mittagessen für unter 3-jährige Kinder',
    shortLabel: 'Betreuung unter 3-Jähriger',
    values: {
      ja: {
        label: 'Mittagessen vorhanden',
        color: '#be0021',
        order: 0,
      },
    },
    kooperationen: ['koop_u3J_GEM'],
  },
  Mittagessen_3_6: {
    label: 'Mittagessen für 3- bis 6-jährige Kinder',
    shortLabel: 'Betreuung 3- bis 6-Jähriger',
    values: {
      ja: {
        label: 'Mittagessen vorhanden',
        color: '#be0021',
        order: 0,
      },
    },
    kooperationen: ['koop_3_6J_GEM'],
  },
  VS_Ki_NMB: {
    label: 'Nachmittagsbetreuung für Volksschulkinder',
    values: {
      ja: {
        label: 'Nachmittagsbetreuung vorhanden',
        color: '#be0021',
        order: 0,
      },
    },
    kooperationen: ['koop_NMB_GEM'],
  },
}



// WEBPACK FOOTER //
// ./src/data/FieldDefinitions.js